import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
{
    id: "hs-04-h4v0-01",
    name: "PO 01 - H4V0",
    albumType: "Hr",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 152, y: 114, width: 413, height: 309, rotation: 0, imageRotation: 0 },
            { id: "2", x: 152, y: 431, width: 413, height: 309, rotation: 0, imageRotation: 0 },
            { id: "3", x: 573, y: 114, width: 412, height: 309, rotation: 0, imageRotation: 0 },
            { id: "4", x: 573, y: 431, width: 412, height: 309, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h4v0-02",
    name: "PO 02 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 73, y: 106, width: 423, height: 317, rotation: 0, imageRotation: 0 },
        { id: "2", x: 73, y: 431, width: 423, height: 317, rotation: 0, imageRotation: 0 },
        { id: "3", x: 640, y: 106, width: 423, height: 317, rotation: 0, imageRotation: 0 },
        { id: "4", x: 640, y: 431, width: 423, height: 317, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-03",
    name: "PO 03 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 310, width: 279, height: 233, rotation: 0, imageRotation: 0 },
        { id: "2", x: 287, y: 310, width: 278, height: 233, rotation: 0, imageRotation: 0 },
        { id: "3", x: 573, y: 310, width: 278, height: 233, rotation: 0, imageRotation: 0 },
        { id: "4", x: 859, y: 310, width: 278, height: 233, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-04",
    name: "PO 04 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 525, width: 278, height: 233, rotation: 0, imageRotation: 0 },
        { id: "2", x: 286, y: 525, width: 278, height: 233, rotation: 0, imageRotation: 0 },
        { id: "3", x: 572, y: 525, width: 278, height: 233, rotation: 0, imageRotation: 0 },
        { id: "4", x: 858, y: 525, width: 278, height: 233, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-05",
    name: "PO 05 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 48, y: 69, width: 474, height: 355, rotation: 0, imageRotation: 0 },
        { id: "2", x: 48, y: 432, width: 474, height: 354, rotation: 0, imageRotation: 0 },
        { id: "3", x: 615, y: 69, width: 474, height: 355, rotation: 0, imageRotation: 0 },
        { id: "4", x: 615, y: 432, width: 474, height: 354, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-06",
    name: "PO 06 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
    size: [1136, 854],
    style: {},
    slots: [      
        { id: "1", x: 55, y: 73, width: 303, height: 231, rotation: 0, imageRotation: 0 },
        { id: "2", x: 55, y: 312, width: 303, height: 231, rotation: 0, imageRotation: 0 },
        { id: "3", x: 55, y: 551, width: 303, height: 231, rotation: 0, imageRotation: 0 },
        { id: "4", x: 622, y: 255, width: 461, height: 345, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-07",
    name: "PO 07 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 57, y: 195, width: 454, height: 466, rotation: 0, imageRotation: 0 },
        { id: "2", x: 622, y: 195, width: 461, height: 314, rotation: 0, imageRotation: 0 },
        { id: "3", x: 622, y: 517, width: 227, height: 144, rotation: 0, imageRotation: 0 },
        { id: "4", x: 857, y: 517, width: 226, height: 144, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-08",
    name: "PO 08 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
    size: [1136, 854],
    style: {},
    slots: [       
        { id: "1", x: 63, y: 92, width: 286, height: 218, rotation: 0, imageRotation: 0 },
        { id: "2", x: 63, y: 318, width: 286, height: 218, rotation: 0, imageRotation: 0 },
        { id: "3", x: 63, y: 544, width: 286, height: 218, rotation: 0, imageRotation: 0 },
        { id: "4", x: 357, y: 92, width: 717, height: 670, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-09",
    name: "PO 09 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
    size: [1136, 854],
    style: {},
    slots: [    
        { id: "1", x: 110, y: 158, width: 224, height: 174, rotation: 0, imageRotation: 0 },
        { id: "2", x: 110, y: 340, width: 224, height: 174, rotation: 0, imageRotation: 0 },
        { id: "3", x: 110, y: 522, width: 224, height: 174, rotation: 0, imageRotation: 0 },
        { id: "4", x: 342, y: 158, width: 684, height: 538, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h4v0-10",
    name: "PO 10 - H4V0",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 29, y: 33, width: 522, height: 392, rotation: 0, imageRotation: 0 },
        { id: "2", x: 29, y: 433, width: 522, height: 391, rotation: 0, imageRotation: 0 },
        { id: "3", x: 586, y: 33, width: 522, height: 392, rotation: 0, imageRotation: 0 },
        { id: "4", x: 586, y: 433, width: 522, height: 391, rotation: 0, imageRotation: 0 }
    ],
}
];